import { useContext } from 'react';
import styled from 'styled-components';

import { PanelSection } from '../SidePanel';
import { LONG_AREA_UNITS, ROW_UNITS } from '../../constants/units';
import {
  asDynamicDecimal,
  asQuantity,
  unitForValue,
} from '../../utils/formatters';
import { FieldsPreviewContext, SectionHeader } from './components';
import { useFarmMeta } from './utils/content';
import { LabeledData } from '../right-menu/menu-components';

const Subheader = styled.h4`
  margin: 8px 0;
`;

// NOTE: this hook returns an array with one JSX element, to match the behavior
// of the other use*Info hooks (which return arrays of multiple JSX elements).
// These elements are combined in <FieldsPreview /> and split up based on size,
// to fit in to paginated panels.
export const useSummaryInfo = () => {
  const { isPrintMode, panelVisibility, togglePanelVisibility } = useContext(
    FieldsPreviewContext,
  );

  const {
    totals: { acreage, treeCount, totalRowLength, rowCount },
    sectionCount,
  } = useFarmMeta();

  const header = (
    <SectionHeader
      title="Summary"
      onClick={() => togglePanelVisibility('summary')}
    />
  );

  if (!panelVisibility.summary) {
    if (isPrintMode) return [];

    return [
      <PanelSection className="opacity-50" key="summary-hidden">
        {header}
      </PanelSection>,
    ];
  }

  return [
    <PanelSection key="summary-shown">
      {header}

      <div>
        <Subheader>Sections</Subheader>
        <LabeledData
          label="area"
          formatter={asDynamicDecimal}
          unitSpec={LONG_AREA_UNITS}
        >
          {acreage}
        </LabeledData>
        <LabeledData
          label="qty"
          unit={unitForValue('sections', 'section')}
          formatter={asQuantity}
        >
          {sectionCount}
        </LabeledData>
        <LabeledData
          label="stems"
          unit={unitForValue('stems', 'stem')}
          formatter={asQuantity}
        >
          {treeCount}
        </LabeledData>
      </div>
      <div>
        <Subheader>Rows</Subheader>
        <LabeledData
          label="length"
          unitSpec={ROW_UNITS}
          formatter={asDynamicDecimal}
        >
          {totalRowLength}
        </LabeledData>
        <LabeledData
          label="qty"
          unit={unitForValue('rows', 'row')}
          formatter={asQuantity}
        >
          {rowCount}
        </LabeledData>
      </div>
    </PanelSection>,
  ];
};
